import React, {
  Fragment,
  useState,
  useEffect,
  useCallback,
  useContext,
} from "react";

import { Search } from "react-feather";
import { Input } from "reactstrap";

import CustomizerContext from "../../Utils/Customizer";

const TableSearch = ({ onSearch }) => {
  const [searchValue, setSearchValue] = useState("");
  const { setIsClose } = useContext(CustomizerContext);
  const [IsOpen, setIsOpen] = useState(false);

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      setSearchValue("");
      setSearchResult([]);
      setIsClose(false);
    }
  }, []);
  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction, searchValue]);

  const handleSearchKeyword = (value) => {
    onSearch(value);
  };

  return (
    <Fragment>
      <div className="left-header horizontal-wrapper  nav-right right-header ">
        <div className={`input-group search-form ${IsOpen ? "open" : ""}`}>
          <Input
            type="text"
            placeholder="Buscar aqui.."
            defaultValue={searchValue}
            onKeyDown={(e) => {
              //if (e.key == "Enter") {
              handleSearchKeyword(e.target.value);
              // }
            }}
          />
          <span className="input-group-text mobile-search">
            <Search />
          </span>
        </div>
      </div>
    </Fragment>
  );
};
export default TableSearch;
